import fetch from "../fetch";

export default ({ params = {} } = {}) =>
  fetch({ path: `/hy/hurdle-types`, params });
